@if (showCheckIcon) {
  <mat-icon
    class="qaroni-mat-icon-30 qaroni-text-success"
    [matTooltip]="confirmationTooltip"
    >check_circle</mat-icon
  >
}
